const ROUTE_VIEW_SETTING = [
  // 我的
  { path: '/setting', name: '设置', h5Uri: '/setting/setting', nativeUri: null, whiteList: false },
  { path: '/modifyData', name: '修改资料', h5Uri: '/setting/modify_data', nativeUri: null, whiteList: false },
  { path: '/modifyPassword', name: '修改密码', h5Uri: '/setting/modify_password', nativeUri: null, whiteList: false },
  { path: '/opinion', name: '意见反馈', h5Uri: '/setting/opinion', nativeUri: null, whiteList: false },
  { path: '/about', name: '关于我们', h5Uri: '/setting/about', nativeUri: null, whiteList: false },
  { path: '/modifyId', name: '修改身份证号码', h5Uri: '/setting/modify_id', nativeUri: null, whiteList: false },
  { path: '/delete', name: '账号注销', h5Uri: '/setting/delete', nativeUri: null, whiteList: false },
  { path: '/modifyMobile', name: '修改手机号码', h5Uri: '/setting/modify_mobile', nativeUri: null, whiteList: false }
]

export default ROUTE_VIEW_SETTING



// WEBPACK FOOTER //
// ./src/router/mapping/setting.js